// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/upper-winds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/upper-winds/fb-interpolation.js';
import g1 from '../lessons/meteorology/upper-winds/fb-route-wind.js';

mount([g0, g1]);
